module.exports = __webpack_public_path__ + "fonts/SourceHanSans-Regular.34e10c5.woff";